import { AuthContext } from '../../contexts/AuthContext';
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { Typography, TextField, Button } from '@material-ui/core';

const VerifyEmailPage = () => {
  const history = useHistory();
  const { setUser, setIsAuthenticated } = useContext(AuthContext);
  const [code, setCode] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  // 初回コード送信
  useEffect(() => {
    const sendCode = async () => {
      try {
        await Auth.verifyCurrentUserAttribute('email');
        setSuccess('認証コードを送信しました。メールをご確認ください。');
      } catch (err) {
        console.error('コード送信失敗:', err);
        setError('認証コードの送信に失敗しました');
      }
    };

    sendCode();
  }, []);

  // コード確認処理
  const handleVerify = async () => {
    try {
      await Auth.verifyCurrentUserAttributeSubmit('email', code);
      setSuccess('メール認証が完了しました！');
      setError('');

      const user = await Auth.currentAuthenticatedUser();
      setUser(user);
      setIsAuthenticated(true);

      setTimeout(() => history.push('/'), 2000);
    } catch (err) {
      console.error('認証エラー:', err);
      setError('認証コードが正しくありません');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '0 auto', padding: 20 }}>
      <Typography variant="h6">メール認証</Typography>
      <TextField
        label="認証コード"
        fullWidth
        margin="normal"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />
      {error && <Typography color="error">{error}</Typography>}
      {success && <Typography color="primary">{success}</Typography>}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleVerify}
        style={{ marginTop: 20 }}
      >
        認証する
      </Button>
    </div>
  );
};

export default VerifyEmailPage;
